import { render, staticRenderFns } from "./authorizationAdd.vue?vue&type=template&id=389aefc5&scoped=true&"
import script from "./authorizationAdd.vue?vue&type=script&lang=js&"
export * from "./authorizationAdd.vue?vue&type=script&lang=js&"
import style0 from "./authorizationAdd.vue?vue&type=style&index=0&id=389aefc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389aefc5",
  null
  
)

export default component.exports